<template>
    <section>
        <CaddyPreview :caddy="data"></CaddyPreview>
        <div>
            <table class="caddy">
                <thead>
                    <th colspan="2">Ladders</th>
                </thead>

                <tbody>
                    <tr>
                        <td><label for="ladderWidth">Width :</label></td>
                        <td><input v-model.number="data.ladderWidth" type="number" id="ladderWidth" name="ladderWidth" /> mm</td>
                    </tr>

                    <tr>
                        <td><label for="ladderHeight">Height :</label></td>
                        <td><input v-model.number="data.ladderHeight" type="number" id="ladderHeight" name="ladderHeight" /> mm</td>
                    </tr>

                    <tr>
                        <td><label for="topPawl">Top pitch :</label></td>
                        <td><input v-model.number="topPawl" type="number" id="topPawl" name="topPawl" /> mm</td>
                    </tr>
                    <tr>
                        <td><label for="bottomPawl">Bottom pitch :</label></td>
                        <td><input v-model.number="bottomPawl" type="number" id="bottomPawl" name="bottomPawl" /> mm</td>
                    </tr>
                    <tr>
                        <td><label for="pawlInterval">Pitch interval :</label></td>
                        <td><input v-model.number="data.pawlInterval" type="number" id="pawlInterval" name="pawlInterval" /> mm</td>
                    </tr>
                    <tr>
                        <td><label for="intermediateLadderCount">Intermediate ladder count :</label></td>
                        <td>
                            <input
                                v-model.number="data.intermediateLadderCount"
                                type="number"
                                id="intermediateLadderCount"
                                name="intermediateLadderCount"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <RoundedButton @click="data.clipDevices = [{ x: 0, y: 0 }];">Reset anchors</RoundedButton>
            <RoundedButton @click="data.clipDevices.push({ x: 0, y: 0 });">Add an anchor</RoundedButton>
        </div>
    </section>
</template>

<script>
import CaddyPreview from "./caddy-preview";
import RoundedButton from "./components/rounded-button";

export default {
    components: { CaddyPreview, RoundedButton },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    methods: {
        addAnchor() {
            this.data.clipDevices.push({
                x: 0,
                y: 0
            });
        },
        remove(index) {
            this.data.clipDevices.splice(index, 1);
        }
    },
    computed: {
        bottomPawl: {
            get() {
                return -this.data.bottomPawl;
            },
            set(value) {
                this.data.bottomPawl = -value;
            }
        },
        topPawl: {
            get() {
                return this.data.topPawl + this.data.contentHeight;
            },
            set(value) {
                this.data.topPawl = value - this.data.contentHeight;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
input {
    width: 130px;
}

#main table.caddy {
    align-self: start;
    width: unset;
}

section {
    flex-grow: 1;
    margin-right: 10px;
    padding: 10px;
    display: flex;
    flex-direction: row;

    > figure {
        flex-grow: 1;
    }

    > div {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        > button {
            margin-top: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// caddy-form.vue?16a86058